import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { skillQueryKeys } from "./skillQueryKeys";

export function useDeleteSkill(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (skillId: string) =>
      skillService.deleteSkill(skillId, { orgId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.org(orgId),
      });
    },
  });
}
